/*用户数据*/

const state={
    login: false,
    phone: '',
    password: '',
    role: '',
    token: '',
};
const getters={
    login: state => state.login,
    phone: state => state.phone,
    password: state => state.password,
    role: state => state.role,
    token: state => state.token,
};
const actions={
};
const mutations={
    setRole(state,data){
        state.role = data;
    },
    setLogin(state,data){
        if(data.status){
            state.login = data.status;
            state.phone = data.phone;
            state.password = data.password;
            state.role = data.role;
            state.token = data.token;
            window.localStorage.setItem('phone',data.phone);
            window.localStorage.setItem('password',data.password);
            window.localStorage.setItem('loginTime',data.loginTime);
            window.localStorage.setItem('role',data.role);
            window.localStorage.setItem('token',data.token);
        }else{
            state.login = false;
            state.phone = '';
            state.password = '';
            state.role = '';
            state.token = '';
            window.localStorage.clear();
        }
    }
};

export default {
    namespaced:true,
    state,
    getters,
    mutations,
    actions
}
